/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  Upload,
  Modal,
  message,
  Spin,
  Tooltip,
} from "antd";
import API from "../../../api";
import urls from "../../../api/urls";
import { CopyOutlined } from "@ant-design/icons";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import "./style.scss";
import useCustomNavigate from "../../../components/customNavigationHook";
import { maintenanceConfig } from "../../../config/maintenance";

function LoginForm({
  errorMessage,
  onFinish,
  handleForgot,
  userDetails,
  setUserDetails,
  loading,
  setModalVisible,
  modalVisible,
  validateOTP = () => {},
  getUserEmail = () => {},
  validateEmail = () => {},
}) {
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();

  const [userName, setUserName] = useState(null);
  // const [pasteEmail, setPasteEmail] = useState(null);
  const navigate = useCustomNavigate();

  useEffect(() => {
    //localStorage.setItem("showPalletitModal", "true");
    localStorage.setItem("showClientEditModal", "true");
  }, []);

  useEffect(() => {
    if (userDetails?.updatedEmail) {
      modalForm.setFieldsValue({
        email: userDetails?.updatedEmail,
        // mobile: userDetails?.data?.mobile || 89898989,
      });
    }
    if (userDetails?.validEmail) {
      setUserDetails((prev) => ({
        ...prev,
        disableValidateEmail: true,
      }));

      // Set disableValidateEmail to false after 30 seconds
      const timer = setTimeout(() => {
        setUserDetails((prev) => ({
          ...prev,
          disableValidateEmail: false,
        }));
      }, 30000); // 30 seconds in milliseconds

      // Cleanup the timer if the component unmounts or re-renders
      return () => clearTimeout(timer);
    }
  }, [loading]);

  function copyText(text) {
    // setPasteEmail(pasteEmail);
    navigator.clipboard.writeText(text);
    // form.setFieldValue("username", text);
  }

  function handleCloseModal() {
    setModalVisible(false);
    modalForm.resetFields();
    setUserDetails({});
    setUserName(null);
  }

  return (
    <>
      <Modal
        title={"Sevasetu user details"}
        open={modalVisible}
        maskClosable={false}
        destroyOnClose
        onCancel={handleCloseModal}
        width={700}
        loading={true}
        style={{ marginTop: 30 }}
        className="staff-onboard-modal"
        footer={
          <>
            <div className="d-flex flex-end">
              <Button
                // htmlType="submit"
                onClick={handleCloseModal}
                className="save-btn ml-1"
              >
                CLOSE
              </Button>
            </div>
          </>
        }
      >
        <Spin
          spinning={loading}
          size="large"
          indicator={
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          }
        >
          <Form
            form={modalForm}
            layout="vertical"
            className="global-form"
            style={{ minHeight: "150px" }}
          >
            <Row className="global-form-row  login-modal-container">
              {/* Username Input */}
              <div className="input-group">
                <Form.Item
                  name="username"
                  label="Sevasetu user name"
                  rules={[
                    {
                      message: "User name is required",
                      required: true,
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Sevasetu user name"
                    onChange={(e) => {
                      setUserDetails({});
                      modalForm.setFieldsValue({ email: "", mobile: "" });
                      setUserName(e.target.value);
                    }}
                  />
                </Form.Item>
              </div>

              {/* Get User Details Button */}
              <div className="button-group">
                <Button
                  className="save-btn"
                  onClick={() => getUserEmail(userName)}
                >
                  GET USER DETAILS
                </Button>
              </div>
              {userDetails?.InvalidEmailMessage && (
                <div
                  className="validation-message"
                  style={{ width: "65%", color: "red" }}
                >
                  {userDetails?.InvalidEmailMessage}
                </div>
              )}

              {/* Email Section */}
              {userDetails?.userName && (
                <>
                  <div className="input-group">
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        {
                          message: "Email is required",
                          required: true,
                        },
                      ]}
                    >
                      <Input
                        placeholder=""
                        // type="email"
                        // disabled
                        onChange={(e) => {
                          setUserDetails((prev) => ({
                            ...prev,
                            updatedEmail: e.target.value,
                          }));
                        }}
                      />
                    </Form.Item>
                  </div>
                  {userDetails?.isRegistered == false ||
                  userDetails?.userEmail !== userDetails.updatedEmail ? (
                    <div className="button-group">
                      <Button
                        className="save-btn"
                        // disabled={
                        //   !userDetails?.data?.email_id ||
                        //   userDetails?.disableValidateEmail
                        // }
                        disabled={
                          !userDetails?.userName ||
                          userDetails?.disableValidateEmail
                        }
                        onClick={() => {
                          if (modalForm.getFieldValue("email")) {
                            validateEmail(modalForm.getFieldValue("email"));
                            modalForm.setFieldValue("otp", null);
                          } else {
                            message.error("Please enter E-mail");
                          }
                        }}
                      >
                        VALIDATE EMAIL
                      </Button>
                    </div>
                  ) : null}
                </>
              )}
              {/* {userDetails?.isRegistered == false && (
                <div className="validation-message" style={{ width: "95%" }}>
                  If your email is incorrect or you cannot access it, please
                  update the email and then click on VALIDATE EMAIL
                </div>
              )} */}

              {/* Email Validation Message */}
              {userDetails?.isRegistered == true &&
                userDetails?.userEmail === userDetails?.updatedEmail && (
                  <div className="validation-message" style={{ width: "65%" }}>
                    {/* {userDetails?.validEmailMessage} */}
                    An account with this email already exists. Please log in
                    using the same email or reset your password if needed.
                  </div>
                )}

              {/* OTP Section */}
              {userDetails?.validEmail && (
                <>
                  <div className="input-group">
                    <Form.Item
                      name="otp"
                      label="OTP"
                      rules={[
                        {
                          message: "OTP is required",
                          required: true,
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter OTP"
                        maxLength={6}
                        onChange={() => {
                          setUserDetails((prev) => ({
                            ...prev,
                            otpVerified: false,
                          }));
                        }}
                      />
                    </Form.Item>
                  </div>
                  <div className="button-group">
                    <Button
                      className="save-btn"
                      disabled={userDetails?.otpVerified} // chnage to true for 200
                      onClick={() => {
                        validateOTP(modalForm.getFieldValue("otp"));
                        // setUserDetails((prev) => ({
                        //   ...prev,
                        //   otpVerified: true,
                        // }));
                        // message.success("OTP verified");
                      }}
                    >
                      VERIFY OTP
                    </Button>
                  </div>
                </>
              )}

              {/* OTP Verified Section */}
              {/* {userDetails.otpVerified && (
                <div className="otp-verified">
                  <Input
                    placeholder=""
                    disabled
                    value={userDetails?.data?.email_id}
                    suffix={
                      <Tooltip title="Copy to clipboard" placement="bottom">
                        <CopyOutlined
                          className="pointer"
                          onClick={() => copyText(userDetails?.data?.email_id)}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              )} */}
              {userDetails.isRegistered && (
                <div className="otp-verified">
                  <Input
                    placeholder=""
                    disabled
                    value={userDetails?.userEmail}
                    suffix={
                      <Tooltip title="Copy to clipboard" placement="bottom">
                        <CopyOutlined
                          className="pointer"
                          onClick={() => copyText(userDetails?.userEmail)}
                        />
                      </Tooltip>
                    }
                  />
                </div>
              )}
              {userDetails?.optSuccessMessage && (
                <div
                  className="validation-message-success"
                  style={{ fontSize: 14 }}
                >
                  {/* first case if passsord exits (flag)*/}
                  {userDetails?.optSuccessMessage}
                  <a onClick={() => navigate("/forgotPassword")}>
                    {" "}
                    Forgot Password link
                  </a>{" "}
                </div>
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>

            {/* Prominent Info Bar - Top of Page */}
      <div className="login-info-bar prominent">
        <div className="info-content">
          <span className="info-icon">💡</span>
          <span className="info-text">
            <strong>Important:</strong> Use the same credentials for login which you&apos;re using for <span className="url-text">bookings.innofulfill.com</span>
          </span>
        </div>
      </div>

      <div className="login-container-headding">
        <div>
          Login To Your Account
          {/* {!maintenanceConfig.isActive && (
            <div
              style={{
                textAlign: "right",
                fontWeight: "800",
                color: "#3C2DB0",
                fontSize: 16,
                textDecoration: "underline",
              }}
              className="pointer web-screen"
              onClick={() => {
                message.destroy();
                setModalVisible(true);
                localStorage.setItem("showNotice", false);
              }}
            >
              CREATE NEW USER
            </div>
          )} */}
        </div>
      </div>

      <div className="login-container-subheadding">
        Prompt, Quick & Reliable Services
      </div>
      {!maintenanceConfig.isActive && (
        <div
          style={{
            textAlign: "right",
            fontWeight: "800",
            color: "#3C2DB0",
            fontSize: 16,
            textDecoration: "underline",
          }}
          className="pointer mb-screen"
          onClick={() => {
            message.destroy();
            setModalVisible(true);
            localStorage.setItem("showNotice", false);
          }}
        >
          CREATE NEW USER
        </div>
      )}

      <Form
        // style={{ marginTop: "5%" }}
        onFinish={onFinish}
        form={form}
        autoComplete="on"
        initialValues={
          {
            // username: "priyaranjan@hutechsolutions.com",
            // password: "Hutech@1234",
            // name:"sdhjdhhjs"
          }
        }
      >
        <div className="login-container-email" style={{ marginTop: 0 }}>
          Email
        </div>

        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: "Enter your email address",
            },
          ]}
        >
          <Input
            className="login-container-email-input"
            placeholder="Enter your email address"
            maxLength={75}
            bordered={false}
            // value={pasteEmail || "assasasa"}
          />
        </Form.Item>
        <div className="login-container-email" style={{ marginTop: "30px" }}>
          Password
        </div>
        <div>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Enter your password",
              },
            ]}
          >
            <Input.Password
              className="login-container-email-input"
              placeholder="Password"
              bordered={false}
            />
          </Form.Item>
        </div>
        <div className="error">
          <p>{errorMessage}</p>
        </div>
        <div className="login-container-remember">
          {/* <div
                style={{
                display: "flex",
                columnGap: "10px",
                }}
            >
            <Checkbox
              onChange={(e) => setRememberMe(!rememberMe)}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  setRememberMe(!rememberMe);
                  e.preventDefault();
                }
              }}
              defaultChecked={rememberMe}
              checked={rememberMe}
            />
            <span className="rememberMe">Remember me</span>
          </div> */}
          <div className="login-container-forgot" onClick={handleForgot}>
            Forgot Password ?
          </div>
        </div>

        <Form.Item>
          <div className="login-container-btndiv">
            <Button
              className="save-btn mt-2"
              size="large"
              htmlType="submit"
              block
            >
              LOGIN
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
}

export default LoginForm;
